import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const createQuotationTemplate = createAsyncThunk(
  'quotationTemplates/create',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BackendURL}/quotationtemplate/save`, formData);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchAllQuotationTemplates = createAsyncThunk(
  'quotationTemplates/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BackendURL}/quotationtemplate/all`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateQuotationTemplate = createAsyncThunk(
  'quotationTemplates/update',
  async ({ id, updatedData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${BackendURL}/quotationtemplate/update/${id}`, updatedData);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteQuotationTemplate = createAsyncThunk(
  'quotationTemplates/delete',
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`${BackendURL}/quotationtemplate/delete/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const quotationTemplateSlice = createSlice({
  name: 'quotationTemplates',
  initialState: {
    templates: [],
    loading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder

    .addCase(createQuotationTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createQuotationTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.templates.push(action.payload);
      })
      .addCase(createQuotationTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchAllQuotationTemplates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllQuotationTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.templates = action.payload;
      })
      .addCase(fetchAllQuotationTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateQuotationTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateQuotationTemplate.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.templates.findIndex(t => t._id === action.payload._id);
        if (index !== -1) state.templates[index] = action.payload;
      })
      .addCase(updateQuotationTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteQuotationTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteQuotationTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.templates = state.templates.filter(t => t._id !== action.payload);
      })
      .addCase(deleteQuotationTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default quotationTemplateSlice.reducer;
